module.exports = __webpack_public_path__ + "resources/wait-89c8da972b602ad363e0464e89d0229e.svg";